
import styled from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { MarketingButton } from 'common/styles/oc-styled-components';

export const StyledHeader = styled.h2`
  font-size: 24px;
  line-height: 1.2;
  font-weight: bold;
  margin-bottom: 0;
  text-align: center;
  width: 220px;
`;

export const StyledP = styled.p`
  font-size: 14px;
  line-height: 1.5;
  font-weight: normal;
  text-align: center;
  margin: 10px auto 5px;
`;

interface StyledButtonProps {
  type: 'primary' | 'secondary';
}
export const StyledButton = styled(MarketingButton)<StyledButtonProps>`
  && {
    height: initial;
    display: flex;
    justify-content: center;
    ${(props) =>
      props.type === 'primary'
      && `
      font-weight: bold;
      padding: 10px 25px;
      color: ${BRAND_COLORS.white};
      margin: 10px 0;
    `}
    ${(props) =>
      props.type === 'secondary'
      && `
      border: 0 !important;
      font-size: 14px;
      text-decoration: underline !important;
    `}
  }
`;
